import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { getSocket } from '../lib/socket';
import { SOCKET_EVENTS } from '@shared/constants';

export function useSocketEvents() {
  const qc = useQueryClient();

  useEffect(() => {
    const socket = getSocket();

    socket.on(SOCKET_EVENTS.ALERT_NEW, (alert: { title: string; message: string; severity: string }) => {
      toast.warning(alert.title, { description: alert.message });
      void qc.invalidateQueries({ queryKey: ['alerts'] });
    });
    socket.on(SOCKET_EVENTS.IMPORT_DONE, () => {
      toast.success('Import terminé', { description: 'Catégorisation et analyse en cours' });
      void qc.invalidateQueries({ queryKey: ['transactions'] });
      void qc.invalidateQueries({ queryKey: ['imports'] });
      void qc.invalidateQueries({ queryKey: ['kpis'] });
    });
    socket.on(SOCKET_EVENTS.CATEGORIZATION_DONE, () => {
      void qc.invalidateQueries({ queryKey: ['transactions'] });
    });
    socket.on(SOCKET_EVENTS.INSIGHT_NEW, (data: { type: string }) => {
      toast.info('Nouveau bilan disponible', { description: data.type });
      void qc.invalidateQueries({ queryKey: ['insights'] });
    });

    return () => {
      socket.off(SOCKET_EVENTS.ALERT_NEW);
      socket.off(SOCKET_EVENTS.IMPORT_DONE);
      socket.off(SOCKET_EVENTS.CATEGORIZATION_DONE);
      socket.off(SOCKET_EVENTS.INSIGHT_NEW);
    };
  }, [qc]);
}
